<style lang="stylus" scoped>
@import '../cardMap.stylus';

.map-card-cont .map-card-lib:nth-child(even) {
  background: #F8F8F8;
}

.map-card {
  border: 1px solid #ccc;
}
</style>
<template>
  <div class="map-card">
    <div class="map-card-cont" style="top:0;" v-if="cardItem&&cardItem.length">
      <div
        class="map-card-lib"
        style="margin-top:0;border:0;border-radius:0;"
        v-for="(it,index) in list"
        :key="index"
      >
        <div class="_lib1">{{it.name}}</div>
        <div class="_lib3">{{format(it.value)}}次</div>
      </div>
    </div>
    <div class="map-card-cont" style="top:0;" v-if="cardItem&&cardItem.item&&cardItem.item.length">
      <div class="map-card-lib" style="margin-top:0;border:0;border-radius:0;">
        <div class="_lib1">合计</div>
        <div class="_lib3">{{format(cardItem.toatl)}}次</div>
      </div>
      <div
        class="map-card-lib"
        style="margin-top:0;border:0;border-radius:0;"
        v-for="(it,index) in list"
        :key="index"
      >
        <div class="_lib1">{{it.name}}</div>
        <div class="_lib3">{{format(it.value)}}次</div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/api/cardData'
import Bus from '@/utils/Bus.js'
export default {
  name: 'mapCard',
  data() {
    return {
      cardItemLeth: 0,
      details: {},
      list: []
    }
  },
  props: {
    cardItem: [Array, Object],
    time: Array,
  },
  watch: {
    cardItem: function(value, oldValue) {
        if (this.cardItem.length) {
          let list = this.cardItem.slice(0)
          list.sort((a, b) => {
            return  b.value * 1 - a.value * 1
          })
          this.list = [...list]
        } else {
          let list = this.cardItem.item.slice(0)
          list.sort((a, b) => {
            return b.value * 1 - a.value * 1
          })
          this.list = [...list]
        }
    }
  },
  created() {},
  mounted() {
    if (this.cardItem.length) {
      let list = this.cardItem
      list.sort((a, b) => {
        return a.value * 1 - b.value * 1
      })
      this.list = [...list]
    } else {
      let list = this.cardItem.item
      list.sort((a, b) => {
        return a.value * 1 - b.value * 1
      })
      this.list = [...list]
    }
  },
  methods: {
    format(num) {
      if (num == -1) {
        return '--'
      } else {
        var reg = /\d{1,3}(?=(\d{3})+$)/g
        return (num + '').replace(reg, '$&,')
      }
    }
  }
}
</script>
